module.exports = __webpack_public_path__ + "img/ig.b90c4bfd.png";